import React, { type FC, type PropsWithChildren } from 'react';

type TikTokProps = {
  /** The color of the icon. */
  color?: string;
};

const TikTok: FC<PropsWithChildren<TikTokProps>> = ({ color = 'currentcolor' }) => (
  <svg height="399" viewBox="0 0 348 399" width="348" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="M295.74 79.91C274.26 65.91 258.77 43.5 253.93 17.39C252.89 11.75 252.31 5.94 252.31 0H183.77L183.66 274.68C182.51 305.44 157.19 330.13 126.16 330.13C116.51 330.13 107.43 327.72 99.43 323.51C81.09 313.86 68.54 294.64 68.54 272.52C68.54 240.75 94.39 214.9 126.15 214.9C132.08 214.9 137.77 215.88 143.15 217.56V147.59C137.58 146.83 131.92 146.36 126.15 146.36C56.59 146.36 0 202.95 0 272.52C0 315.2 21.32 352.97 53.86 375.81C74.35 390.2 99.28 398.67 126.16 398.67C195.72 398.67 252.31 342.08 252.31 272.52V133.23C279.19 152.52 312.13 163.89 347.67 163.89V95.35C328.53 95.35 310.7 89.66 295.74 79.91Z"
        fill={color}
      />
    </g>
  </svg>
);

export default TikTok;
